import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Header — newspaper masthead. Centered, with section numerals (I/II/III/IV).
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 bg-[#F4EEE0] border-b transition-all ${scrolled ? 'border-[#1A1410] py-3' : 'border-[#1A1410]/60 py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[1fr_auto_1fr] items-center gap-6">
        <div className="hidden md:block font-mono text-[10px] tracking-[0.32em] uppercase text-[#1A1410]/55">
          The Open Letter · {META.issue.split('·')[0].trim()}
        </div>
        <button onClick={() => setPage('home')} data-testid="mv-logo" className="text-center">
          <p className="font-serif italic text-3xl text-[#7B1A1A] -mb-1">{META.brand}</p>
          <p className="font-mono text-[8px] tracking-[0.55em] uppercase text-[#1A1410]/60">— Field Notes —</p>
        </button>
        <nav className="hidden md:flex items-center justify-end gap-6">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`mv-nav-${r.id}`} className={`group flex items-baseline gap-1.5 transition-colors ${page === r.id ? 'text-[#7B1A1A]' : 'text-[#1A1410]/65 hover:text-[#1A1410]'}`}>
              <span className="font-mono text-[9px] tracking-[0.3em] uppercase opacity-50 group-hover:opacity-100">§ {r.no}</span>
              <span className="font-serif italic text-base">{r.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
